import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M15 2a3 3 0 0 0-3 3v4h-2V5a5 5 0 0 1 10 0v2a1 1 0 1 1-2 0V5a3 3 0 0 0-3-3",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#171717",
      d: "M12 18H2a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2"
    }, null, -1)
  ]))]))
}
export default { render: render }